import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useOrderFullscreenModalLayoutFix } from '../../../../../hooks/order/useOrderFullscreenModalLayoutFix';

/** 订单全屏 Modal 壳：统一铺满视口并修正滚动条补偿导致的左右留白 */
const OrderFullscreenModal = ({ show, onHide, children, className, contentClassName, ...rest }) => {
	useOrderFullscreenModalLayoutFix(show);

	return (
		<Modal
			show={show}
			onHide={onHide}
			fullscreen
			className={classNames('order-fullscreen-modal', className)}
			contentClassName={classNames('border', contentClassName)}
			{...rest}
		>
			{children}
		</Modal>
	);
};

OrderFullscreenModal.propTypes = {
	show: PropTypes.bool,
	onHide: PropTypes.func.isRequired,
	children: PropTypes.node,
	className: PropTypes.string,
	contentClassName: PropTypes.string,
};

export default OrderFullscreenModal;
